import React from "react";

export default (props) => (
    <button
        {...props}
        type="button"
        className={"btn btn-primary"}
    ></button>
);
